const GET_MEDIUM_DATA_PENDING: string = 'GET_MEDIUM_DATA_PENDING'
const GET_MEDIUM_DATA_SUCCESS: string = 'GET_MEDIUM_DATA_SUCCESS'
const GET_MEDIUM_DATA_ERROR: string = 'GET_MEDIUM_DATA_ERROR'
const GET_MEDIUM_DATA_INIT: string = 'GET_MEDIUM_DATA_INIT'

export { GET_MEDIUM_DATA_PENDING, GET_MEDIUM_DATA_SUCCESS, GET_MEDIUM_DATA_ERROR, GET_MEDIUM_DATA_INIT }
